// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FoundersRouteImport } from './routes/founders'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as MethodRouteImport } from './routes/method'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAppRouteImport } from './routes/_authenticated/app'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app.index'
import { Route as AuthenticatedAppAppointmentsRouteImport } from './routes/_authenticated/app.appointments'
import { Route as AuthenticatedAppContactsRouteImport } from './routes/_authenticated/app.contacts'
import { Route as AuthenticatedAppDashboardRouteImport } from './routes/_authenticated/app.dashboard'
import { Route as AuthenticatedAppFocusRouteImport } from './routes/_authenticated/app.focus'
import { Route as AuthenticatedAppHistoryRouteImport } from './routes/_authenticated/app.history'
import { Route as AuthenticatedAppIdeasRouteImport } from './routes/_authenticated/app.ideas'
import { Route as AuthenticatedAppInviteRouteImport } from './routes/_authenticated/app.invite'
import { Route as AuthenticatedAppJournalRouteImport } from './routes/_authenticated/app.journal'
import { Route as AuthenticatedAppSettingsRouteImport } from './routes/_authenticated/app.settings'
import { Route as AuthenticatedAppTodayRouteImport } from './routes/_authenticated/app.today'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FoundersRoute = FoundersRouteImport.update({
            id: '/founders',path: '/founders',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const MethodRoute = MethodRouteImport.update({
            id: '/method',path: '/method',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppRoute = AuthenticatedAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAppointmentsRoute = AuthenticatedAppAppointmentsRouteImport.update({
            id: '/appointments',path: '/appointments',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppContactsRoute = AuthenticatedAppContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppDashboardRoute = AuthenticatedAppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppFocusRoute = AuthenticatedAppFocusRouteImport.update({
            id: '/focus',path: '/focus',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppHistoryRoute = AuthenticatedAppHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppIdeasRoute = AuthenticatedAppIdeasRouteImport.update({
            id: '/ideas',path: '/ideas',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppInviteRoute = AuthenticatedAppInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppJournalRoute = AuthenticatedAppJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsRoute = AuthenticatedAppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppTodayRoute = AuthenticatedAppTodayRouteImport.update({
            id: '/today',path: '/today',getParentRoute: () => AuthenticatedAppRoute
          })





const AuthenticatedAppRouteChildren = {
  AuthenticatedAppAppointmentsRoute: AuthenticatedAppAppointmentsRoute,AuthenticatedAppContactsRoute: AuthenticatedAppContactsRoute,AuthenticatedAppDashboardRoute: AuthenticatedAppDashboardRoute,AuthenticatedAppFocusRoute: AuthenticatedAppFocusRoute,AuthenticatedAppHistoryRoute: AuthenticatedAppHistoryRoute,AuthenticatedAppIdeasRoute: AuthenticatedAppIdeasRoute,AuthenticatedAppInviteRoute: AuthenticatedAppInviteRoute,AuthenticatedAppJournalRoute: AuthenticatedAppJournalRoute,AuthenticatedAppSettingsRoute: AuthenticatedAppSettingsRoute,AuthenticatedAppTodayRoute: AuthenticatedAppTodayRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute
}

const AuthenticatedAppRouteWithChildren = AuthenticatedAppRoute._addFileChildren(AuthenticatedAppRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAppRoute: AuthenticatedAppRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,FaqRoute: FaqRoute,FoundersRoute: FoundersRoute,LegalRoute: LegalRoute,MethodRoute: MethodRoute,PricingRoute: PricingRoute,ResetPasswordRoute: ResetPasswordRoute,SecurityRoute: SecurityRoute,BlogSlugRoute: BlogSlugRoute,GlossarySlugRoute: GlossarySlugRoute,BlogIndexRoute: BlogIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)